import axios from 'axios';

console.log('API URL:', process.env.REACT_APP_API_URL);

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://www.sozialgerichtsbarkeit.de/api/',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor für das Hinzufügen des Auth-Tokens
apiClient.interceptors.request.use(
  (config) => {
    // Lese den Token direkt aus dem localStorage für jede Anfrage
    // So wird immer der aktuelle Token verwendet
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // Wenn kein Token vorhanden ist, entferne den Authorization-Header
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor für die Fehlerbehandlung
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Bei 401-Fehler Token entfernen und zur Login-Seite weiterleiten
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
); 
